export const PASSWORD_MIN_LENGTH = 8;

export type PasswordAdvisory = 'predictable';

const COMMON_PASSWORD_PARTS = ['password', 'qwerty', 'letmein', 'welcome', 'admin'];

export function meetsPasswordMinimum(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH;
}

export function getPasswordAdvisory(password: string): PasswordAdvisory | null {
  const normalizedPassword = password.toLowerCase().replace(/[^a-z0-9]/g, '');

  if (!normalizedPassword) {
    return null;
  }

  if (
    COMMON_PASSWORD_PARTS.some((part) => normalizedPassword.includes(part)) ||
    /(.)\1{3,}/.test(normalizedPassword) ||
    hasSequentialRun(normalizedPassword)
  ) {
    return 'predictable';
  }

  return null;
}

export function isPasswordPolicyRejection(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const authError = error as { code?: unknown; message?: unknown; error_description?: unknown };
  const code = typeof authError.code === 'string' ? authError.code.toLowerCase() : '';
  const message = [authError.message, authError.error_description]
    .filter((value): value is string => typeof value === 'string')
    .join(' ')
    .toLowerCase();

  return (
    code.includes('weak_password') ||
    message.includes('weak password') ||
    message.includes('password is too weak') ||
    message.includes('leaked password')
  );
}

function hasSequentialRun(value: string): boolean {
  let ascendingRun = 1;
  let descendingRun = 1;

  for (let index = 1; index < value.length; index += 1) {
    const previousCode = value.charCodeAt(index - 1);
    const currentCode = value.charCodeAt(index);

    ascendingRun = currentCode === previousCode + 1 ? ascendingRun + 1 : 1;
    descendingRun = currentCode === previousCode - 1 ? descendingRun + 1 : 1;

    if (ascendingRun >= 4 || descendingRun >= 4) {
      return true;
    }
  }

  return false;
}